import React, {useCallback, useEffect, useState} from 'react';
import './AIModal.scss';
import GeneralModal from "../../Modals/GeneralModal/GeneralModal";
import i18next from "i18next";
import AIDocumentsList from "../../Lists/AIDocumentsList/AIDocumentsList";
import LabeledDelayedInput from "../../Custom UI/LabeledInputs/LabeledDelayedInput/LabeledDelayedInput";

const AIModal = ({open, ai, client, close, company, didAddAI, removeAIDocument, addAI, addAIDocument, fetchAI, didUpdateAI}) => {
  
  // Instance Variables
  
  const [id, setId] = useState('');
  const [name, setName] = useState('');
  const [saving, setSaving] = useState(false);
  const [keyword, setKeyword] = useState('');
  const [description, setDescription] = useState('');
  
  // Effects
  
  useEffect(() => {
    if(ai && ai.id && ai.id.length > 0){
      if(ai.id !== id){
        setId(ai.id);
        setName(ai.name);
        setKeyword(ai.keyword);
        setDescription(ai.description);
        fetchAI(ai.id).then((newResult) => {
          didUpdateAI(newResult.data.data.ai_model);
        }, (newError) => {

        });
      }
    }
    else{
      setId('');
      setName('');
      setKeyword('');
      setDescription('');
    }
  }, [ai, id, fetchAI]);
  
  // Methods
  
  const saveAI = useCallback(() => {
    setSaving(true);
    const isUpdating = ai && ai.id && ai.id.length > 0;
    addAI(isUpdating ? ai.id : undefined, name, keyword, description).then((newResult) => {
      setSaving(false);
      
      if(isUpdating){
        didUpdateAI(newResult.data.data.saveAiModelMutation.ai_model);
      }
      else{
        didAddAI(newResult.data.data.saveAiModelMutation.ai_model);
      }
    }, (newError) => {
      setSaving(false);
      console.log('Mike newError:', newError);
    });
  }, [ai, name, addAI, keyword, didAddAI, description, didUpdateAI]);
  
  // Render
  
  return (
    // <GeneralModal open={open}
    //               close={close}
    //               width={'calc(100vw - 80px)'}
    //               height={'calc(100vh - 174px)'}
    //               showCancelButton={false}>
    <GeneralModal title={i18next.t(ai && ai.id && ai.id.length > 0 ? 'UPDATE_AI' : 'CREATE_AI')}
                  width={'calc(100vw - 30px)'}
                  height={ai && ai.id && ai.id.length > 0 ? 'calc(100vh - 30px)' : '400px'}
                  isOpen={open}
                  loading={saving}
                  maxWidth={1300}
                  maxHeight={800}
                  handleSave={saveAI}
                  description={i18next.t(ai && ai.id && ai.id.length > 0 ? 'UPDATE_AI_DESCRIPTION' : 'CREATE_AI_DESCRIPTION')}
                  noTitleHeading={true}
                  showSaveButton={true}
                  handleCloseModal={() => close()}
                  maxChildrenHeight={800}>
      <div className="ai-modal-input-container">
        <LabeledDelayedInput className="ai-modal-input"
                             label={i18next.t('AI_NAME')}
                             value={name}
                             disabled={saving}
                             handleSave={(aEvent) => setName(aEvent.target.value)}
                             placeholder={i18next.t('AI_NAME')}
        />
        
        <LabeledDelayedInput className="ai-modal-input"
                             label={i18next.t('AI_KEYWORD')}
                             value={keyword}
                             disabled={saving}
                             handleSave={(aEvent) => setKeyword(aEvent.target.value)}
                             placeholder={i18next.t('AI_KEYWORD')}
        />
      </div>
      
      <LabeledDelayedInput className="ai-modal-textarea"
                           label={i18next.t('AI_DESCRIPTION')}
                           value={description}
                           element={'textarea'}
                           disabled={saving}
                           handleSave={(aEvent) => setDescription(aEvent.target.value)}
                           placeholder={i18next.t('AI_DESCRIPTION')}
      />
      
      <AIDocumentsList ai={ai}
                       client={client}
                       company={company}
                       didUpdateAI={didUpdateAI}
                       addAIDocument={addAIDocument}
                       removeAIDocument={removeAIDocument}
      />
    </GeneralModal>
  );
};

export default AIModal
